import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import {SelectorPerfilesContainer as SelectorPerfiles} from '../../../../components/Selectores/Perfiles/container';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [año, setAño] = useState(selected ? selected.año.toLocaleString() : undefined);
  let [tasaIS, setTasaIS] = useState(selected ? selected.tasa_IS_Matriz.toLocaleString() : undefined);
  let [tasaGGrales, setTasaGGrales] = useState(selected ? selected.tasa_GtosGrales.toLocaleString() : undefined);
  
  const getData = () =>{
    let data = { año: Number.parseInt(año), Tasa_IS_Matriz: Number.parseFloat(tasaIS.replace(',', '.')), Tasa_GtosGrales: Number.parseFloat(tasaGGrales.replace(',', '.'))}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidAño)
  }

  const isNumber = (value) =>{
    var val = Number.parseFloat(value);
    if (typeof val === 'number' && !isNaN(val) && val.toLocaleString() == value) {
      return true;
    }else{
      return false;
    }
  }

  const isInvalidAño = useMemo(() => {return año===undefined || !isNumber(año)},[año, isNumber])

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Año" isInvalid={isInvalidAño}>
          <EuiFieldText fullWidth value={año} name="txtAño" onChange={e => setAño(e.target.value)} isInvalid={isInvalidAño}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Tasa IS" /*isInvalid={isInvalidEmail}*/>
          <EuiFieldText fullWidth value={tasaIS} name="txttasaIS" onChange={e => setTasaIS(e.target.value)} /*isInvalid={isInvalidNombre}*//>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Tasa Gtos Grales" /*isInvalid={isInvalidPerfil}*/>
        <EuiFieldText fullWidth value={tasaGGrales} name="txttasaGGrales" onChange={e => setTasaGGrales(e.target.value)} /*isInvalid={isInvalidNombre}*//>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;